import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "../lib/api";

// Catch-all resolver: before falling back to home, check the CMS-managed redirect map so a
// managed 301/302 wins the race. Awaits the map (brief) rather than letting the router bounce to '/'.
export default function RedirectResolver() {
  const location = useLocation();
  const [state, setState] = useState({ status: "loading", to: null });

  useEffect(() => {
    let alive = true;
    api.get("/redirects/active")
      .then((r) => {
        if (!alive) return;
        const match = (r.data || []).find((x) => x.from_path === location.pathname);
        if (match && match.to_path !== location.pathname) {
          api.post("/redirects/hit", { from_path: location.pathname }).catch(() => {});
          if (match.to_path.startsWith("http")) { window.location.href = match.to_path; return; }
          setState({ status: "redirect", to: match.to_path });
        } else {
          setState({ status: "home", to: null });
        }
      })
      .catch(() => alive && setState({ status: "home", to: null }));
    return () => { alive = false; };
  }, [location.pathname]);

  if (state.status === "loading") return null;
  if (state.status === "redirect") return <Navigate to={state.to} replace />;
  return <Navigate to="/" replace />;
}
